import React from "react";
import { TouchableOpacity, Text, ActivityIndicator } from "react-native";

import { useAppTheme } from '../../../design-system/ThemeProvider';
import { useLanguageStore } from "../../../features/quiz-core/languageStore";
import { t } from "../../../i18n/translations";
import { createAuthStyles } from "../AuthScreen.styles";

interface SocialButtonProps {
  loading: boolean;
  onPress: () => void;
  onPressIn: () => void;
  onPressOut: () => void;
  socialScale: number;
  socialShadow: number;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  loading,
  onPress,
  onPressIn,
  onPressOut,
  socialScale,
  socialShadow
}) => {
  const { colors } = useAppTheme();
  const styles = createAuthStyles(colors);
  const { language } = useLanguageStore();

  return (
  <TouchableOpacity
    style={[
      styles.socialButton,
      loading && styles.disabledButton,
      { transform: [{ scale: socialScale }] }
    ]}
    onPress={onPress}
    disabled={loading}
    activeOpacity={0.8}
    onPressIn={onPressIn}
    onPressOut={onPressOut}
  >
    <Text style={styles.googleIcon}>G</Text>
    <Text style={styles.socialButtonText}>
      {loading ? t('auth.connecting', language) : t('auth.continueWithGoogle', language)}
    </Text>
    {loading && (
      <ActivityIndicator size="small" color="#4F46E5" style={styles.buttonLoader} />
    )}
  </TouchableOpacity>
  );
};

export default SocialButton;
